module.exports = require("../../../lib").google.rpc;
